import { Trans, t } from "@lingui/macro";
import RecoverySourceConfirmDrawer from "./RecoverySourceConfirmDrawer";

type RecoverySourceTurnOffDrawerProps = {
  sourceName: string;
  // Apple Health is the HRV source (TAJ-1628); every other provider keeps the recovery wording.
  appleHealth?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Confirmation before a source is switched off: nothing auto-selects a replacement, so the
// recovery response score stops.
const RecoverySourceTurnOffDrawer = ({
  sourceName,
  appleHealth = false,
  onConfirm,
  onCancel,
}: RecoverySourceTurnOffDrawerProps) => (
  <RecoverySourceConfirmDrawer
    title={
      appleHealth
        ? t`Are you sure you want to turn off ${sourceName} as your HRV data source?`
        : t`Are you sure you want to turn off ${sourceName} as a Recovery data source?`
    }
    body={<Trans>If you do, your Recovery Response score will no longer be calculated.</Trans>}
    confirmLabel={<Trans>Yes, turn off</Trans>}
    cancelLabel={<Trans>No, keep on</Trans>}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default RecoverySourceTurnOffDrawer;
